module.exports = __webpack_public_path__ + "static/mmo-photo-794369df79f3cb95323b3840d83f96df.jpg";